/* oxlint-disable tailwindcss/no-unknown-classes -- Styles are colocated in searchmark-results.css. */
import type { CSSProperties } from "react"

import { searchmarkSummary, sections } from "./searchmark-data"

import "./searchmark-results.css"

export function SearchmarkResults() {
  return (
    <figure className="searchmark-results not-prose">
      <div className="searchmark-results__header">
        <strong>Searchmark results</strong>
        <span>{searchmarkSummary}</span>
      </div>
      <div className="searchmark-results__scroll">
        <table>
          <thead>
            <tr>
              <th scope="col">Scenario</th>
              <th className="searchmark-results__col--no-search" scope="col">
                No search
              </th>
              <th className="searchmark-results__col--search" scope="col">
                Search
              </th>
            </tr>
          </thead>
          {sections.map((section) => (
            <tbody key={section.title}>
              <tr className="searchmark-results__section">
                <th colSpan={3} scope="colgroup">
                  {section.title}
                </th>
              </tr>
              {section.rows.map((row) => (
                <tr
                  key={row.label}
                  style={{ "--searchmark-row-alpha": `${row.accentOpacity}%` } as CSSProperties}
                >
                  <th scope="row">
                    {row.label}
                    <small>{row.note}</small>
                  </th>
                  <td className="searchmark-results__col--no-search">{row.noSearch}</td>
                  <td className="searchmark-results__col--search">{row.search}</td>
                </tr>
              ))}
            </tbody>
          ))}
        </table>
      </div>
    </figure>
  )
}
